import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { staggeredBaseQuery } from './staggeredBaseQuery'; 

export const baseApi = createApi({
    reducerPath: "baseApi",
    baseQuery: staggeredBaseQuery(""),
    tagTypes: ["JobOrder", "ProfileJobOrder", "JobPosting", "Dispatch", "JobOrderHistory"],
    endpoints: () => ({})
})